'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.PrintablePage = void 0

var _react = _interopRequireDefault(require('react'))

var _styledComponents = _interopRequireDefault(require('styled-components'))

var _index = require('../../molecules/Flex/index.js')

var _templateObject

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

var PrintablePage = function PrintablePage(_ref) {
  var children = _ref.children
  return /*#__PURE__*/ _react['default'].createElement(
    Page,
    null,
    /*#__PURE__*/ _react['default'].createElement(
      _index.Flex,
      {
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      },
      children
    )
  )
}

exports.PrintablePage = PrintablePage

var Page = _styledComponents['default'].div(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  width: 100%;\n  padding: 25mm;\n  padding-top: 10mm;\n  padding-bottom: 0;\n  margin: 0;\n  background: white;\n  ',
      '\n\n  @media print {\n    margin: 0;\n    box-shadow: none;\n    padding: 10mm;\n  }\n\n  body {\n    overflow-y: visible !important;\n  }\n\n  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.23);\n\n  * {\n    box-sizing: border-box;\n  }\n\n  table {\n    border-spacing: 0px;\n    border-collapse: collapse;\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 15px;\n    background-color: transparent; /* Change the background-color of table here */\n    text-align: left; /* Change the text-alignment of table here */\n  }\n\n  th {\n    font-weight: bold;\n    border: 1px solid #cccccc; /* Change the border-color of heading here */\n    padding: 8px;\n  }\n\n  td {\n    border: 1px solid #cccccc; /* Change the border-color of cells here */\n    padding: 8px;\n  }\n\n  /* Stylized */\n\n  /* Adding Striped Effect for odd rows */\n\n  tr {\n    background-color: transparent; /* Change the default background-color of rows here */\n  }\n\n  tr:nth-of-type(2n + 1) {\n    background-color: #eeeeee; /* Change the background-color of odd rows here */\n  }\n\n  tr th {\n    background-color: #dddddd; /* Change the background-color of heading here */\n  }\n\n  /* Adding Hover Effect for rows */\n\n  tr {\n    -moz-transition: background-color 300ms ease-in-out 0s;\n    -ms-transition: background-color 300ms ease-in-out 0s;\n    -o-transition: background-color 300ms ease-in-out 0s;\n    -webkit-transition: background-color 300ms ease-in-out 0s;\n    transition: background-color 300ms ease-in-out 0s;\n  }\n\n  /* Removing left and right border of rows for modern UIs */\n\n  tr {\n    border-top: 1px solid #cccccc;\n    border-bottom: 1px solid #cccccc;\n  }\n\n  th,\n  td {\n    border: none;\n  }\n',
    ])),
  '@page {\n    size: A4;\n  }'
)
